import update from 'react-addons-update';

import {
  ADD_CARDS_DATA,
  DELETE_CARD_DATA_BY_KEY,
  ADD_CARDS_DATA_DB,
  ORIGINAL_INDEX,
  DELETE_CAROUSEL_IMAGE_BY_KEY,
  DELETE_LIST_IMAGE_BY_KEY,
  ADD_ACTIONS,
  RESET_REDUX_STORE,
  ADD_ORIGINAL_INDEX,
  CHANGE_POSITION_ORIGINAL_INDEX,
  ADD_CAROUSEL_DATA,
  ADD_CAROUSEL_ACTION_CHOICES,
  DELETE_BUTTON,
  DELETE_BUTTON_CAROUSEL,
  DELETE_BUTTON_API_PARAM,
  UPDATE_ACTIONS,
  UPDATE_CAROUSEL_ACTIONS,
  UPDATE_THUMBNAIL_INDEX,
  UPDATE_API_PARAM_ACTIONS,
  UPDATE_API_TEMPLATE_ACTIONS,
  ADD_API_PARAM_DATA,
} from '../types/conversationPreview';

export const conversationPreviewReducer = (state = [], action) => {
  switch (action.type) {
    case ADD_CARDS_DATA:
      return addConvCardsData(state, action);
    case DELETE_CARD_DATA_BY_KEY:
      return deleteConvCardData(state, action);
    case ADD_CARDS_DATA_DB:
      return addConvCardsDataDb(state, action);
    case ORIGINAL_INDEX:
      return addOriginalIndex(state, action);
    case ADD_ACTIONS:
      return addActions(state, action);
    case ADD_ORIGINAL_INDEX:
      return addOriginalIndextoarray(state, action);
    case CHANGE_POSITION_ORIGINAL_INDEX:
      return changePositionOrigiIndArray(state, action);
    case ADD_CAROUSEL_DATA:
      return addCarouselData(state, action);
    case ADD_CAROUSEL_ACTION_CHOICES:
      return addCarouselActionChoices(state, action);
    case ADD_API_PARAM_DATA:
      return addAPIParamData(state, action);
    case DELETE_BUTTON:
      return deleteButton(state, action);
    case DELETE_BUTTON_CAROUSEL:
      return deleteCarouselButton(state, action);
    case DELETE_BUTTON_API_PARAM:
      return deleteButtonAPIParam(state, action);
    case RESET_REDUX_STORE: {
      return (state = []);
    }
    case DELETE_CAROUSEL_IMAGE_BY_KEY:
      return deleteCarouselCardData(state, action);
    case DELETE_LIST_IMAGE_BY_KEY:
      return deleteListCardData(state, action);
    case UPDATE_ACTIONS:
      return updateActions(state, action);
    case UPDATE_CAROUSEL_ACTIONS:
      return updateCarouselActionChoices(state, action);
    case UPDATE_API_PARAM_ACTIONS:
      return updateAPIParamActionChoices(state, action);
    case UPDATE_API_TEMPLATE_ACTIONS:
      return updateAPITemplateAction(state, action);
    case UPDATE_THUMBNAIL_INDEX:
      return updateCarouselThumbnailInd(state, action);
    default:
      return state;
  }
};

function addConvCardsData(state, action) {
  const { stateKey, isLoading } = action.payload;
  if (state.length != 0) {
    return update(state, { 0: { $merge: { [stateKey]: isLoading } } });
  }
  return [...state, { [stateKey]: isLoading }];
}

function deleteCarouselCardData(state, action) {
  const { choice, stateKey, index, intent_id } = action.payload;
  if (state.length != 0) {
    stateKey.forEach(function (key) {
      delete state[0][key][choice].image_url;
      delete state[0][key][choice].image_preview;
    });
  }
  if (typeof index !== 'undefined' && index != null) {
    state[0]['original_index_array_' + intent_id].splice(index, 1);
  }

  if (Array.isArray(state)) return [...state];
  return state;
}

function deleteListCardData(state, action) {
  const { Listindex, stateKey } = action.payload;
  if (state.length != 0) {
    stateKey.forEach(function (key) {
      delete state[0][key][Listindex].image_url;
      delete state[0][key][Listindex].image_preview;
    });
  }
  return [...state];
}

function deleteConvCardData(state, action) {
  const { stateKey, index, intent_id } = action.payload;
  if (state[0].length != 0) {
    stateKey.forEach(function (key) {
      if (typeof state[0][key] !== 'undefined') delete state[0][key];
    });
  }
  if (index != null) {
    state[0]['original_index_array_' + intent_id].splice(index, 1);
  }
  if (Array.isArray(state)) return [...state];
  return state;
}

function addConvCardsDataDb(state, action) {
  const { data, intent_id } = action.payload;
  let result = [];
  let carousel_array;
  data.forEach((card, index) => {
    if (index == 0) {
      if (card.action_type == 7) {
        carousel_array = getCarouselChoicesfromDb(card.intent_carousel);
        result = [
          { ['carousel_card_' + intent_id + '_' + index]: carousel_array },
        ];
      } else if (card.action_type == 11) {
        carousel_array = getCarouselChoicesfromDb(card.intent_carousel);
        result = [
          {
            ['carousel_card_' + intent_id + '_' + index]: carousel_array,
            ['param1_' + intent_id + '_' + index]: card.param1,
            ['intent_choice_' + intent_id + '_' + index]: card.intent_choices,
          },
        ];
      } else if (card.action_type == 8) {
        result = [
          {
            ['API_card_param_' + intent_id + '_' + index]: card.api_params,
            ['param1_' + intent_id + '_' + index]: card.param1,
            ['API_card_template_' + intent_id + '_' + index]:
              card.api_templates,
          },
        ];
      } else if (card.action_type == 13) {
        result = [
          {
            ['param2_' + intent_id + '_' + index]: card.param2,
            ['param1_' + intent_id + '_' + index]: card.param1,
          },
        ];
      } else if (card.action_type == 3) {
        result = [
          {
            ['param2_' + intent_id + '_' + index]: card.param2,
            ['param1_' + intent_id + '_' + index]: card.param1,
          },
        ];
      } else {
        result = [
          {
            ['param1_' + intent_id + '_' + index]: card.param1,
            ['param2_' + intent_id + '_' + index]:
              card.param2 != undefined ? card.param2 : null,
            ['param3_' + intent_id + '_' + index]: card.param3,
            ['cust_attr_id_' + intent_id + '_' + index]: card.cust_attr_id,
            ['intent_choice_' + intent_id + '_' + index]: card.intent_choices,
          },
        ];
      }
    } else {
      if (card.action_type == 7) {
        carousel_array = getCarouselChoicesfromDb(card.intent_carousel);
        result = update(result, {
          0: {
            $merge: {
              ['carousel_card_' + intent_id + '_' + index]: carousel_array,
            },
          },
        });
      } else if (card.action_type == 11) {
        carousel_array = getCarouselChoicesfromDb(card.intent_carousel);
        result = update(result, {
          0: {
            $merge: {
              ['carousel_card_' + intent_id + '_' + index]: carousel_array,
              ['param1_' + intent_id + '_' + index]: card.param1,
              ['intent_choice_' + intent_id + '_' + index]: card.intent_choices,
            },
          },
        });
      } else if (card.action_type == 8) {
        result = update(result, {
          0: {
            $merge: {
              ['API_card_param_' + intent_id + '_' + index]: card.api_params,
              ['param1_' + intent_id + '_' + index]: card.param1,
              ['API_card_template_' + intent_id + '_' + index]:
                card.api_templates,
            },
          },
        });
      } else if (card.action_type == 13) {
        result = update(result, {
          0: {
            $merge: {
              ['param2_' + intent_id + '_' + index]: card.param2,
              ['param1_' + intent_id + '_' + index]: card.param1,
            },
          },
        });
      } else if (card.action_type == 3) {
        result = update(result, {
          0: {
            $merge: {
              ['param2_' + intent_id + '_' + index]: card.param2,
              ['param1_' + intent_id + '_' + index]: card.param1,
            },
          },
        });
      } else {
        result = update(result, {
          0: {
            $merge: {
              ['param1_' + intent_id + '_' + index]: card.param1,
              ['param2_' + intent_id + '_' + index]:
                card.param2 != undefined ? card.param2 : null,
              ['param3_' + intent_id + '_' + index]: card.param3,
              ['cust_attr_id_' + intent_id + '_' + index]: card.cust_attr_id,
              ['intent_choice_' + intent_id + '_' + index]: card.intent_choices,
            },
          },
        });
      }
    }
  });
  return result;
}

function addOriginalIndex(state, action) {
  if (state.length != 0) {
    return update(state, { 0: { $merge: { original_index: action.payload } } });
  }
  return [...state, { original_index: action.payload }];
}

function addActions(state, action) {
  const { data, originalIndex, intent_id } = action.payload;
  const buttonKey = ['intent_choice_' + intent_id + '_' + originalIndex];
  if (buttonKey in state[0]) {
    return update(state, { 0: { [buttonKey]: { $push: [data] } } });
  }
  return update(state, { 0: { $merge: { [buttonKey]: [data] } } });
}

function addOriginalIndextoarray(state = [], action) {
  const originalIndex = action.payload.originalIndex;
  const intent_id = action.payload.intent_id;
  const actionType = action.payload.actionType;
  const data = { originalIndex: originalIndex, actionType: actionType };
  if (state.length == 0) {
    return [...state, { ['original_index_array_' + intent_id]: [data] }];
  }
  if (['original_index_array_' + intent_id] in state[0]) {
    return update(state, {
      0: { ['original_index_array_' + intent_id]: { $push: [data] } },
    });
  }
  return update(state, {
    0: { $merge: { ['original_index_array_' + intent_id]: [data] } },
  });
}

function changePositionOrigiIndArray(state, action) {
  const { index, changedIndex, intent_id } = action.payload;
  const ori_array = state[0]['original_index_array_' + intent_id];
  const removedItem = ori_array.splice(changedIndex, 1);
  ori_array.splice(index, 0, removedItem[0]);
  return [...state];
}

function addCarouselData(state, action) {
  const { carousel_index, originalIndexCard, data, keyName, intent_id } =
    action.payload;
  const buttonKey = ['carousel_card_' + intent_id + '_' + originalIndexCard];
  if (buttonKey in state[0]) {
    if (state[0][buttonKey].length == carousel_index) {
      return update(state, {
        0: { [buttonKey]: { $push: [{ [keyName]: data }] } },
      });
    }
    return update(state, {
      0: {
        [buttonKey]: { [carousel_index]: { $merge: { [keyName]: data } } },
      },
    });
  }
  return update(state, {
    0: { $merge: { [buttonKey]: [{ [keyName]: data }] } },
  });
}

function addCarouselActionChoices(state = [], action) {
  const { data, originalIndex, carouselIndex, intent_id } = action.payload;
  const buttonKey = ['carousel_card_' + intent_id + '_' + originalIndex];
  if ('carousel_intent_choice' in state[0][buttonKey][carouselIndex]) {
    return update(state, {
      0: {
        [buttonKey]: {
          [carouselIndex]: { carousel_intent_choices: { $push: [data] } },
        },
      },
    });
  }
  return update(state, {
    0: {
      [buttonKey]: {
        [carouselIndex]: { $merge: { carousel_intent_choices: [data] } },
      },
    },
  });
}

function addAPIParamData(state, action) {
  const { keyName, data, originalIndex, intent_id } = action.payload;
  const buttonKey = [keyName + intent_id + '_' + originalIndex];
  if (buttonKey in state[0]) {
    if (state[0][buttonKey].length) {
      return update(state, {
        0: { [buttonKey]: { $push: [data] } },
      });
    }
    return update(state, {
      0: {
        [buttonKey]: { $merge: [data] },
      },
    });
  }
  return update(state, {
    0: {
      $merge: { [buttonKey]: [data] },
    },
  });
}

function getCarouselChoicesfromDb(intent_carousel_db) {
  let h_choose_id = '';
  const carousel_array = [];
  let carousel_object = {};
  let carousel_intent_choice_array = [];
  let carousel_choices_object = {};
  let ind = 0;
  intent_carousel_db.forEach((intent_carousel, index1) => {
    if (index1 === 0 || h_choose_id != intent_carousel.h_choose_id) {
      if (index1 !== 0) {
        ind++;
      }
      h_choose_id = intent_carousel.h_choose_id;
      carousel_object = {};
      carousel_intent_choice_array = [];
      carousel_choices_object = {};
      carousel_object.h_choose_id = intent_carousel.h_choose_id;
      carousel_object.h_choose_title = intent_carousel.h_choose_title;
      carousel_object.h_choose_subtitle = intent_carousel.h_choose_subtitle;
      carousel_object.image_url = intent_carousel.image_url;
      carousel_object.click_url = intent_carousel.click_url;
      if (intent_carousel.h_button_id != null) {
        carousel_choices_object.h_button_id = intent_carousel.h_button_id;
        carousel_choices_object.choice_title = intent_carousel.h_button_title;
        carousel_choices_object.action_type = intent_carousel.action_type;
        carousel_choices_object.action_data = intent_carousel.action_data;
        carousel_choices_object.action_intent_id =
          intent_carousel.action_intent_id;
        carousel_choices_object.action_form_id = intent_carousel.action_form_id;
        carousel_intent_choice_array[0] = carousel_choices_object;
      }
      carousel_array.push(carousel_object);
      carousel_array[ind].carousel_intent_choice = carousel_intent_choice_array;
    } else {
      if (intent_carousel.h_button_id != null) {
        carousel_choices_object = {};
        carousel_choices_object.h_button_id = intent_carousel.h_button_id;
        carousel_choices_object.choice_title = intent_carousel.h_button_title;
        carousel_choices_object.action_type = intent_carousel.action_type;
        carousel_choices_object.action_data = intent_carousel.action_data;
        carousel_choices_object.action_intent_id =
          intent_carousel.action_intent_id;
        carousel_choices_object.action_form_id = intent_carousel.action_form_id;
      }
      carousel_array[ind]['carousel_intent_choice'].push(
        carousel_choices_object
      );
    }
  });
  return carousel_array;
}

function deleteButton(state, action) {
  const { key, button_index } = action.payload;
  state[0][key].splice(button_index, 1);
  return [...state];
}

function deleteCarouselButton(state, action) {
  const { key, button_index, carousel_index } = action.payload;

  state[0][key][carousel_index]['carousel_intent_choice'].splice(
    button_index,
    1
  );
  return [...state];
}

function deleteButtonAPIParam(state, action) {
  const { key, button_index } = action.payload;

  state[0][key].splice(button_index, 1);

  return [...state];
}

function updateActions(state, action) {
  const { data, originalIndex, intent_id, buttonIndex } = action.payload;
  const buttonKey = ['intent_choice_' + intent_id + '_' + originalIndex];
  state[0][buttonKey].splice(buttonIndex, 1, data);
  return [...state];
}

function updateCarouselActionChoices(state, action) {
  const { data, originalIndex, intent_id, buttonIndex, carousel_index } =
    action.payload;
  const buttonKey = ['carousel_card_' + intent_id + '_' + originalIndex];
  state[0][buttonKey][carousel_index]['carousel_intent_choice'].splice(
    buttonIndex,
    1,
    data
  );
  if (Array.isArray(state)) return [...state];
  return state;
}

function updateAPIParamActionChoices(state, action) {
  const { data, originalIndex, intent_id, buttonIndex } = action.payload;
  const buttonKey = ['API_card_param_' + intent_id + '_' + originalIndex];
  state[0][buttonKey].splice(buttonIndex, 1, data);
  return [...state];
}

function updateAPITemplateAction(state, action) {
  const { data, originalIndex, intent_id, buttonIndex } = action.payload;
  const buttonKey = ['API_card_template_' + intent_id + '_' + originalIndex];
  state[0][buttonKey].splice(buttonIndex, 1, data);
  return [...state];
}

function updateCarouselThumbnailInd(state, action) {
  const { draggedInd, droppedInd, Intent, Index } = action.payload;
  const buttonKey = ['carousel_card_' + Intent + '_' + Index];
  const draggedVal = state[0][buttonKey].splice(draggedInd, 1);
  state[0][buttonKey].splice(droppedInd, 0, draggedVal[0]);
  return [...state];
}
